import domReady from '@wordpress/dom-ready';

domReady(() => {
	const blockquoteCarouoselSelector = '.js-block-blockquote-carousel';
	const blockquoteCarouoselItemSelector = '.js-bci';
	const elements = document.querySelectorAll(blockquoteCarouoselSelector);

	if (elements.length) {
		const eventName = new CustomEvent('blockquoteCarouselInit');

		import('./blockquote-carousel').then(({ BlockquoteCarousel }) => {
			[...elements].forEach((element) => {
				const carouselSlider = new BlockquoteCarousel({
					element,
					blockClass: 'block-blockquote-carousel',
					nextElementSelector: `${blockquoteCarouoselItemSelector}-chevron-next`,
					prevElementSelector: `${blockquoteCarouoselItemSelector}-chevron-prev`,
					eventName,
				});
				carouselSlider.init();
			});
		});
	}
});
